
import * as $ from 'jquery';

import * as CanvasTemplates from 'src/integration/canvas/templates';
import * as CanvasPreview from 'src/integration/canvas/ui/preview';
import { throttle } from 'src/integration/canvas/ui/throttleUtil';
import * as CanvasUiUtil from 'src/integration/canvas/ui/util';
import * as AllyIntegrationUtil from 'src/integration/util';
import * as NullUtil from 'src/shared/NullUtil';
import * as AllyConfig from 'src/shared/rest/Config';
import { FileReference } from 'src/shared/rest/domain/FileReference';

// The ids of the files currently on the page
var fileIds = [];

// Constants
const FILE_ID_COLLECTION_INTERVAL = 1000;
/**
 * Throttled version of collectFileIds
 */
const throttleCollectFileIds = throttle(collectFileIds, FILE_ID_COLLECTION_INTERVAL);

/**
 * Initialize the files tool integration if the files tool is currently active
 */
export function init() {
    collectFileIds();
    addFilesToolToolbarButton();
}

/**
 * Add an accessible versions button to the Files tool toolbar. This button will
 * be shown and hidden depending on the current selection in the files tool
 */
function addFilesToolToolbarButton() {
    var downloadSelector = '.ef-header__secondary .ui-buttonset .ui-button.btn-download';
    AllyIntegrationUtil.wait(function() { return $(downloadSelector)[0]; }, function() {
        var $download = $(downloadSelector);
        $download.after(CanvasTemplates.apply('ally-files-accessible-versions-toolbar', {
            'ALLY_DOMAIN': AllyConfig.baseUrl()
        }));

        var $button = $('#ally-accessible-versions-toolbar');
        if ($button && $button.length === 0) {
            $download.after(CanvasTemplates.apply('ally-files-accessible-versions-toolbar', {
                'ALLY_DOMAIN': AllyConfig.baseUrl()
            }));
            initializeTooltip();
        }
    });
}

/**
 * Initialize the tooltip for the accessible versions button
 */
function initializeTooltip() {
    var $button = $('#ally-accessible-versions-toolbar');
    if ($button.length > 0 && !$button.data('ui-tooltip')) {
        $button.tooltip({
            'position': {
                'my': 'center bottom-5',
                'at': 'center top'
            },
            'classes': {
                'ui-tooltip': 'ui-corner-all bottom center'
            }
        });
    }
}

/**
 * Collect the ids of the files in the current tool
 */
function collectFileIds() {
    var collectedFileIds = [];
    var selectedFileIds = [];
    const focusedElement = document.activeElement;

    // Extract the file id from the download links
    $('.ef-item-row .ef-name-col a').each(function() {
        var fileId = CanvasUiUtil.getFileId(this.href);
        if (fileId) {
            collectedFileIds.push(fileId);

            // Check if the file is selected
            var selected = $(this).closest('.ef-item-row.ef-item-selected');
            if (selected[0]) {
                selectedFileIds.push(fileId);
            }
        }
    });

    var previewFileId = AllyIntegrationUtil.getQueryParameters(window.location.href).preview;
    if (previewFileId) {
        collectedFileIds.push(previewFileId);
    }

    // Get the Ally information about the detected files if the
    // current list is different than the previous one
    if (fileIds.toString() !== collectedFileIds.toString()) {
        fileIds = collectedFileIds;
        var fileReferences = fileIds.map(function(fileId) { return new FileReference(fileId); });
        CanvasUiUtil.getFileInformation(fileReferences, function(err) {
            if (!err) {
                enhanceFilesTool();
            }
        });
    }

    // Show or hide the accessible versions toolbar button if a single file is selected and the file has accessible
    // versions available
    var selectedFileId = selectedFileIds[0];
    var selectedFileReference = selectedFileIds.length === 1 && new FileReference(selectedFileId);
    var selectedFileReferenceId = selectedFileReference && selectedFileReference.id();
    var selectedFileInfo = selectedFileReferenceId && CanvasUiUtil.fileInformation()[selectedFileReferenceId];
    if (selectedFileInfo && selectedFileInfo.availableAlternativeFormats.length > 0) {
        // The Canvas button set is rendered through react which doesn't keep our button in the same consistent spot.
        // Assert it's the fourth button in the set and move it if necessary

        $('#ally-accessible-versions-toolbar')
            .attr('data-id', selectedFileId)
            .css({ 'display': 'inline-block' })

            // Show a tooltip when hovering over the accessible versions button in the toolbar
            .tooltip({
                'position': {
                    'my': 'center bottom-5',
                    'at': 'center top'
                },
                'classes': {
                    'ui-tooltip': 'ui-corner-all bottom center'
                }
            });
    } else {
        $('#ally-accessible-versions-toolbar').css({ 'display': 'none' });
    }

    CanvasPreview.pollPreview(
        function($previewFrame) {
            return ($previewFrame.siblings('.ef-file-arrow_container').length === 2);
        },
        function() {
            return AllyIntegrationUtil.getQueryParameters(window.location.href).preview;
        }
    );

    if (NullUtil.hasValue(focusedElement) && document.activeElement !== focusedElement) {

        const restoredElement = document.getElementById(focusedElement.id);
        if (NullUtil.hasValue(restoredElement)) {
            restoredElement.focus(); // Restore focus if it was lost and still exists
        }
    }

    // As it is too cumbersome to fully attach to everything going on
    // on the page, just poll regularly to check for updates
    setTimeout(throttleCollectFileIds, FILE_ID_COLLECTION_INTERVAL); // Increase delay slightly
}

/**
 * Inject Ally functionality into the files tool
 */
function enhanceFilesTool() {
    var atLeastOneFileHasAllyScore = false;
    $.each(CanvasUiUtil.fileInformation(), function(fileId, fileInfo) {
        if (AllyIntegrationUtil.hasScore(fileInfo)) {
            atLeastOneFileHasAllyScore = true;
        }
    });

    // If the current user can manage the files (i.e. they're an instructor/ta) and there's at least 1 file for
    // which we have score information, we add an accessibility column to the table
    if (canManageFilesTool() && atLeastOneFileHasAllyScore) {
        // Add the accessibility column heading
        addFilesToolAccessibilityHeading();

        // Add a cell on every file row for the accessibility column
        $('.ef-item-row').each(function() {
            var $row = $(this);

            // Add/replace the score indicator
            $row.find('.ally-accessibility-indicator').remove();
            $row.find('.ef-size-col').after(CanvasTemplates.apply('ally-files-accessibility-cell'));
        });
    }

    $.each(CanvasUiUtil.fileInformation(), function(fileReferenceId, file) {
        var fileId = file.id;
        var $link = $(`.ef-item-row .ef-name-col a[href*="${ getDownloadPath(file) }"]`);
        if (!$link.length) {
            return;
        }

        var $row = $link.closest('.ef-item-row');

        // Add/replace an accessible versions option to the files list dropdown if the file has at least one
        // accessible version
        $row.find('.ally-accessible-versions-item').remove();
        if (AllyIntegrationUtil.hasAvailableAlternativeFormats(file)) {
            $row
                .find('.ef-links-col ul.al-options li:first')
                .after(CanvasTemplates.apply('ally-files-accessible-versions-dropdown', { 'fileId': fileId }));
        }

        // Add an accessibility score indicator to the file list item if the user can manage the files
        if (AllyIntegrationUtil.hasScore(file) && canManageFilesTool()) {
            var $scoreIndicator = AllyIntegrationUtil.createScoreIndicator(file);
            $('.ally-accessibility-indicator', $row).append($scoreIndicator);
            $('.ally-accessibility-indicator-not-available', $row).remove();
        }

        // If the file can induce seizures, add a guard and a warning tip on the icon if not already
        $link.find('.ally-files-seizure').remove();
        if (file.seizureRisk) {
            $link.find('.ef-thumbnail').append(CanvasTemplates.apply('ally-files-seizure-indicator', {
                'ALLY_DOMAIN': AllyConfig.baseUrl()
            }));
        }
    });
}

/**
 * Add an accessibility column to the Files tool list header. This heading will be used for a column that shows an
 * accessibility indicator for each file
 */
function addFilesToolAccessibilityHeading() {
    // Only add the indicator header if it doesn't exist yet
    var $directoryHeader = $('.ef-directory-header');
    if ($directoryHeader.find('.ally-accessibility-column-header').length === 0) {
        // Accessibility header comes after the size header
        $directoryHeader
            .find('.ef-size-col')
            .after(CanvasTemplates.apply('ally-files-accessibility-column-header'));
    }
}

/**
 * Check whether the current user can manage the files tool
 *
 *  @return {Boolean}    Whether the current user can manage the files tool
 */
function canManageFilesTool() {
    return window.ENV.FILES_CONTEXTS[0] &&
            window.ENV.FILES_CONTEXTS[0].permissions &&
            (window.ENV.FILES_CONTEXTS[0].permissions.manage_files_add ||
                window.ENV.FILES_CONTEXTS[0].permissions.manage_files_delete ||
                window.ENV.FILES_CONTEXTS[0].permissions.manage_files_edit);
}

/**
 * Get a relative download path for the given file.
 *
 * @param  {Object}     fileInfo    The Ally file info object
 * @return {String}                 The relative download path
 */
function getDownloadPath(fileInfo) {
    return `/files/${ fileInfo.id }/download`;
}
